import './index.css'
import './window'
import { loadTranslations } from './services/translations.service.ts'

import { createRoot } from 'react-dom/client'
import { getDefaultStore } from 'jotai'
import { setReplaceableStore } from '@nostr/gadgets/global'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { init as initPool } from './pool.ts'
import { store } from './services/store.service.ts'
import { RELAYLIST_RELAYS } from '@nostr/gadgets/defaults'
import { accountAtom, nip07Login } from './atoms/session'

// @ts-expect-error readonly tuple - runtime mutation intentional
RELAYLIST_RELAYS.length = 0
// @ts-expect-error readonly tuple - runtime mutation intentional
RELAYLIST_RELAYS.push(...window.hallway.universe.indexerUrls)

window.addEventListener('resize', setVh)
window.addEventListener('orientationchange', setVh)
setVh()

Promise.allSettled([initPool(), loadTranslations()])
  .then(() => {
    setReplaceableStore(store)
    ;(async () => {
      try {
        const pubkey = await window.nostr?.peekPublicKey?.()
        if (!pubkey) return
        const account = getDefaultStore().get(accountAtom)
        if (account?.pubkey === pubkey) return
        await nip07Login()
      } catch (err) {
        console.warn('auto login failed:', (err as Error).message)
      }
    })()

    createRoot(document.getElementById('root')!).render(
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    )
  })
  .catch((error) => {
    console.error('Failed to initialize nostr-wasm:', error)

    const alertDiv = document.createElement('div')
    alertDiv.className =
      'fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-red-500 text-white p-5 rounded-lg max-w-[90%] w-[400px] text-center z-[9999] shadow-md'
    alertDiv.innerHTML = `
      <h2 class="mb-2.5 text-lg font-bold">Browser not supported</h2>
      <p>
        Your browser does not support WebAssembly, which is required to run this application.
        Please try enabling it in the settings, using a different browser, or updating your current browser.
      </p>
    `
    document.body.appendChild(alertDiv)
  })

function setVh() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
}
